module.exports = __webpack_public_path__ + "static/media/digital-2.3db2de6c.png";